import { FC, memo } from 'react'
import cn from 'classnames'
import styles from './ProgressBar.module.scss'

type ProgressBarProps = {
  value?: number
  className?: string
}
export const ProgressBar: FC<ProgressBarProps> = memo(function ProgressBar({ value, className }) {
  const percentageValue = value ? `${value}%` : 0
  return (
    <div className={cn(styles.progressBar, className)}>
      <div className={styles.progressValue} style={{ width: percentageValue }} />
    </div>
  )
})
